//  Name: course-processing
import { BLOG_URL, ICON } from '@/config'

export default {
  data () {
    return {
      blog_url: BLOG_URL,
      icon: ICON
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/course-processing/script.js